"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M44.37 39.036L25.752 5.186a2 2 0 0 0-3.5 0L3.63 39.036A2 2 0 0 0 5.383 42h37.234a2 2 0 0 0 1.753-2.964zM24 39a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm-2.4-10V15a1 1 0 0 1 1-1h2.8a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-2.8a1 1 0 0 1-1-1z" })
);




//////////////////
// WEBPACK FOOTER
// ./node_modules/@react/react-spectrum/Icon/Alert/24.js
// module id = 785
// module chunks = 0